import DataAPIAdapter from 'rise-ui/adapters/apis/rise-api/data.js';

export default class CatalogRecordAdapter extends DataAPIAdapter {}
